module.exports = __webpack_public_path__ + "img/safari_settings.9e41f77b.png";